module.exports = __webpack_public_path__ + "static/media/26-8.8864b024.mp3";